import { useT } from "../lib/i18n";

const STATUS_CLASS = {
  Available: "pill pill-available",
  Reserved: "pill pill-reserved",
  Sold: "pill pill-sold",
  "Under Preparation": "pill pill-prep",
  "Under Maintenance": "pill pill-maint",
  Consignment: "pill pill-consign",
  "Out for Inspection": "pill pill-inspect",
  "On Test Drive": "pill pill-testdrive",
  "Returned to Owner": "pill pill-returned",
};

export function useStatusLabel() {
  const { t } = useT();
  return (status) => {
    if (!status) return status;
    const key = `st.${status}`;
    const v = t(key);
    return v && v !== key ? v : status;
  };
}

export default function StatusBadge({ status }) {
  const label = useStatusLabel();
  return (
    <span data-testid={`status-badge-${status?.replace(/\s+/g, "-").toLowerCase()}`} className={STATUS_CLASS[status] || "pill pill-returned"}>
      <span className="inline-block w-1.5 h-1.5 rounded-full bg-current opacity-80" />
      {label(status)}
    </span>
  );
}
